import PropTypes from 'prop-types'
import React from 'react'
import CountryCitizenField from '../question_fields/CountryCitizenField'

const Citizen = props => {
  const { index, name, question, disabled = false, margin } = props
  return <CountryCitizenField index={index} {...question} name={name} disabled={disabled} margin={margin} />
}

const CountryQuestion = {
  Citizen,
  name: 'CountryQuestion'
}

export default CountryQuestion

Citizen.propTypes = {
  disabled: PropTypes.bool,
  index: PropTypes.number,
  margin: PropTypes.string,
  name: PropTypes.string,
  question: PropTypes.object
}
